import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage, isRtl } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import moment from 'moment'
import vs from '../../../helper/vconsole'
import 'swiper/swiper-bundle.min.css'
import http from 'src/helper/http'
import { shareToLink, shareToWhatsapp,shareInviteCode } from 'src/helper/webviewFun'
import { apiGetShareLink } from 'src/helper/gold.js'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
  }

  state = {
    showMask:false,
    code:0,
    gold:0,
    link:"",
    recoList:[],
    lang:langM.en,
    language:'en',
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid: uid
    })

    if (language == 'tr') {
      setDocumentTitle("Davet ve Coins Kazan")
    } else if (language == 'en') {
      setDocumentTitle('Invite and get coins')
    } else if (language == 'ar') {
      setDocumentTitle('دعوة والحصول على عملات معدنية')
    }else {
      setDocumentTitle('Invite and get coins')
    }
    this.getUesrInfoHave()
    this.getRecordList()
  }
  getLink = async ()=> {
    const { res } = await apiGetShareLink()
    this.setState({ link: res,})
    console.log(res)
  }

  getUesrInfoHave = async()=>{
    let res  =  await http.post('/web/invitecode/info')
    if(res.code == 0 ){
      this.setState({ code:res.res.code, gold:res.res.gold, link:res.res.shareLink })
    }
  }

  getRecordList = async()=>{
    let res  =  await http.post('/web/invitecode/record')
    console.log(res)
    if(res.code == 0  && res.res.length>0){
       this.setState({recoList:res.res})
    }
  }
  handleShowMask = ()=>{
    this.setState ({ showMask:true  })
  }
  handleCloseMask = ()=>{

    this.setState ({ showMask:false  })
  }
  stopBubbling= (e)=>{
    e.stopPropagation()
  }

  async handleGetShareLink() {
    console.log('link',this.state.link)
    if (this.state.link && this.state.link != '' && this.state.link.indexOf('coupon=') > -1) {
      shareToLink(this.state.link)
      console.log('link--have')
    } else {
      console.log('link--on')
      const { res } = await apiGetShareLink()
      this.setState({ link: res })
      if (res.indexOf('coupon=') > -1) {
        shareToLink(res)
      }
    }
  }

  async handleGetShareWhatsapp() {
    console.log('app')
    if (this.state.link && this.state.link != '' && this.state.link.indexOf('coupon=') > -1) {
      let link = this.state.link
      // if (brower.isIphone()) {
      //   link = link.replace('&code=','%26code%3d')
      // }
      shareToWhatsapp(this.state.lang.link + ' ' + link)
    } else {
      if (res.indexOf('coupon=') > -1) {
        // if (brower.isIphone()) {
        //   res = res.replace('&code=','%26code%3d')
        // }
        shareToWhatsapp(this.state.lang.link + ' ' + res)
      }
    }
  }
  
  handlecopycode= (e)=>{
    shareToLink(e)
  }
  // 初始化/接口请求初始化

  render() {
    let { lang, language, showMask, code, gold, recoList } = this.state
    return (
      <div  className={`newInvitation ${isRtl(language)?'in-ar':''} ` }>
        <div className='banner-newInvitation'>
           {language == 'en' && <img className='banner-root-img' src='/img/app/newInvitation/banner_en_newInv.png'></img>}
           {language == 'ar' && <img className='banner-root-img' src='/img/app/newInvitation/banner_ar_newInv.png'></img>}
           {language == 'tr' && <img className='banner-root-img' src='/img/app/newInvitation/banner_tr_newInv.png'></img>}
        </div>
        <div className='body-newInvitation'>
           <div className='get-icon-root'>
             <div className='root-title-get'>
              <div className='line-left'></div>
              <div className='title-text'>{ lang.totalConisText }</div>
              <div className='line-right'></div>
             </div>
             <div className='get-num'>
               <img className='get-num-img' src={'/img/app/newInvitation/icon_coin_.png'}></img>
               <div className='get-num-text'>{gold}</div>
             </div>
           </div>
           <div className='init-code-view'>
            <div className='rounded-corners-left'></div>
            <div className='rounded-corners-right'></div>
            <div className='init-code-view-top'>
            <div className='view-left'>{lang.initCodeText}</div>
            <div className='view-rigth'>
              <div className='in-text'>{code}</div>
              <img onClick={()=>this.handlecopycode(code)} src='/img/app/newInvitation/icon_copy_brown.png'></img>
            </div>
            </div>
            <div className='get-tip'>{lang.goldTopTip}</div>
            <div className='get-tip'>{lang.goldTip}</div>
           </div>
           
           <div className='submit-btn' onClick={this.handleShowMask}>
              {lang.applyText}
           </div>
           <div className='list-root'>
            <div className='list-root-title'>
              <div className='line-left'></div>
              <div className='title-text'>{lang.listTitle}</div>
              <div className='line-right'></div>
            </div>
            {recoList.length>0 && recoList.map((item,index)=>(<div className='list-item'  key={index}>
              <div className='list-item-left'>
                  <img src={item.avatarurl}></img>
                  <div className='id-text'>UID:{item.duid}</div>
              </div>
              <div className='list-item-right'>{moment(item.registerTs*1000).format('YYYY-MM-DD HH:mm:ss')}</div>
            </div>))}
            
           </div>
        </div>
        <div className='mask-layer' style={{display:`${showMask?'block':'none'}`}}  onClick={ this.handleCloseMask} >
          <div className='handle-root' onClick={this.stopBubbling}>
            <div className='mask-block-line'></div>
            <div className='mask-title-tip'>{lang.initCodeText}</div>
            <div className='mask-show-code-root'>
              <div>{code}</div>
              <img onClick={()=>this.handlecopycode(code)} src='/img/app/newInvitation/icon_cpoy.png'></img>
            </div>
            <div className='dividing-line'></div>
            <div className='share-root'>
                <div className='share-item' onClick={()=>this.handleGetShareLink()}>
                   <img src='/img/app/newInvitation/icon_share.png'></img>
                   <div>{lang.copylinkText}</div>
                </div>
                <div className='share-item' onClick={()=>this.handleGetShareWhatsapp()}>
                   <img src='/img/app/newInvitation/icon_share_whatsapp.png'></img>
                   <div>{lang.whatappText}</div>
                </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/newInvitation/index.js